import React, { useState } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import InwardTab from "./InwardTab";
import OutwardTab from "./OutwardTab";

const InwardOutwardModal = ({ show, onHide, clientId, reportId, port_code_id }) => {
    const [activeTab, setActiveTab] = useState("inward");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>Generate Transfer Letters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabChange}
                    className="mb-3 custom-tabs"
                    justify
                >
                    <Tab eventKey="inward" title="Inward">
                        <InwardTab
                            clientId={clientId}
                            reportId={reportId}
                            port_code_id={port_code_id}
                            type="inward"
                        />
                    </Tab>
                    <Tab eventKey="outward" title="Outward">
                        <OutwardTab
                            clientId={clientId}
                            reportId={reportId}
                            port_code_id={port_code_id}
                            type="outward"
                        />
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};

export default InwardOutwardModal;